<template>
  <zm-radio-group
    v-model="innerValue"
    v-bind="$attrs"
    v-on="{
      ...$listeners,
      input: handleRadioGroupInput,
      change: () => {},
    }"
  >
    <template v-for="slot in Object.keys({...$scopedSlots, ...$slots})" :slot="slot" slot-scope="scope">
      <slot :name="slot" v-bind="scope"></slot>
    </template>
  </zm-radio-group>
</template>
<script>
export default {
  name: 'zb-radio-group',
  data() {
    return {
      innerValue: '',
      nextValue: ''
    };
  },
  props: {
    value: [String, Number, Boolean, Array],
    action: Function,
  },
  methods: {
    handleRadioGroupInput() {
      this.$nextTick(async () => {
        this.nextValue = this.innerValue;
        this.innerValue = this.value;
        if(this.action) {
          await this.action.call(this, this.value, this.nextValue);
        }
        this.$emit('input', this.nextValue);
        this.innerValue = this.nextValue;
        this.$emit('change', this.nextValue);
      })
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.innerValue = this.value;
      },
    }
  }
}
</script>
